
export const trimmedGaCookieValue = () => {
  const gaCookieValue = document.cookie?.split(`; `)?.find(row => row.startsWith(`_ga=`))?.split(`=`)[1];
  
  // Take the last two array items
  return gaCookieValue?.split(`.`).slice(-2).join(`.`)
}
